import React from "react";

const CreditPackagesList = React.lazy(() => import('src/pages/credit_packages/CreditPackagesList'));
const AddCreditPackages = React.lazy(() => import('src/pages/credit_packages/AddCreditPackages'));
const EditCreditPackages = React.lazy(() => import('src/pages/credit_packages/EditCreditPackages'));

const routes = [
    { path: '/dashboard/credit-package-list/add', name: 'Add', element: AddCreditPackages },
    { path: '/dashboard/credit-package-list/edit', name: 'Edit', element: EditCreditPackages },
    { path: '/dashboard/credit-package-list', name: 'Coin Package', element: CreditPackagesList },
];

export default routes;